/**
 * BE BOLD : Path B: Release and Rebuild
 * Month 3: Three Movements Together (Days 61-90)
 *
 * All three movements present. SQUEEZE at 30% max. Pain-free only.
 *
 * All sessions verified at 300s +/-20s (5 minutes)
 * Generated: 2026-04-13 02:14
 *
 * bebold.au | Paula Tomazetti | 16+ years of study
 * All content is 100% Be Bold.
 */

export const exercises = {

  belly_breath_drop: {
    id: 'belly_breath_drop',
    name: 'Belly Breath Drop',
    name_pt: 'Respiro da Barriga',
    sub: 'The floor drops on the inhale. Stay soft on the exhale.',
    sub_pt: 'O assoalho cai na inspiração. Fique macia na expiração.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back with your knees bent and feet flat. Place one hand on your lower belly.

Inhale slowly through your nose for 4 counts. Feel your belly rise under your hand. Your pelvic floor drops gently as your belly expands. You do not push it. It falls on its own.

Exhale through your mouth for 6 counts. Stay soft. Nothing tightens on the exhale. The floor stays dropped.

If you feel nothing at first, that is your starting point.

Picture it: your pelvic floor is a hammock between two trees. Each inhale, the hammock sinks wider. Each exhale, it stays low.`,
    inst_pt: `Deite de costas com os joelhos dobrados e pés apoiados. Coloque uma mão na barriga baixa.

Inspire lentamente pelo nariz por 4 tempos. Sinta a barriga subir sob sua mão. Seu assoalho pélvico desce suavemente conforme a barriga expande. Você não empurra. Ele cai sozinho.

Expire pela boca por 6 tempos. Fique macia. Nada contrai na expiração. O assoalho continua solto.

Se não sentir nada no início, esse é seu ponto de partida.

Visualize: seu assoalho pélvico é uma rede entre duas árvores. Cada inspiração, a rede afunda e alarga. Cada expiração, ela fica baixa.`,
    breathe: 'Inhale 4 counts to drop. Exhale 6 counts to stay soft.',
    breathe_pt: 'Inspire 4 tempos para soltar. Expire 6 tempos para ficar macia.',
    timerCue: `Inhale.
Drop.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Solte.
Expire.
Fique macia.`,
    feel: 'A subtle widening and heaviness in the pelvic bowl on every inhale. Nothing tense. Nothing forced.',
    feel_pt: 'Uma sutil abertura e peso na pelve a cada inspiração. Nada tenso. Nada forçado.',
    avoid: 'Do not push the floor down. Do not bear down. Do not tighten on the exhale.',
    avoid_pt: 'Não empurre o assoalho para baixo. Não faça força. Não contraia na expiração.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  child_pose_release: {
    id: 'child_pose_release',
    pose: 'child-pose',
    name: 'Child Pose Release',
    name_pt: 'Soltura na Posição Criança',
    sub: 'The deepest passive stretch for a tight floor.',
    sub_pt: 'O alongamento passivo mais profundo para um assoalho tenso.',
    level: 'Release',
    zone: 'Full floor 0-6cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Kneel on a soft surface. Bring your knees wide apart. Sit back onto your heels. Stretch your arms forward on the floor.

Let your forehead rest on the floor or on a pillow. Let your belly hang between your thighs.

Inhale for 4 counts. Feel your belly expand toward the floor. Your pelvic floor lengthens between your sit bones.

Exhale for 6 counts. Let everything drop heavier. Gravity pulls your belly down and your floor opens.

Stay here for the full time. No effort. No movement. Just breathing into the stretch.

Picture it: a cat stretching after a nap. Front paws forward, hips back, belly dropped. Total surrender. Or draping a wet towel over a round surface. The towel has no shape of its own. It just falls over whatever is underneath.`,
    inst_pt: `Ajoelhe numa superfície macia. Abra os joelhos bem. Sente nos calcanhares. Estique os braços para frente no chão.

Deixe a testa descansar no chão ou num travesseiro. Deixe a barriga pendurar entre as coxas.

Inspire por 4 tempos. Sinta a barriga expandir em direção ao chão. Seu assoalho pélvico se alonga entre os ísquios.

Expire por 6 tempos. Deixe tudo cair mais pesado. A gravidade puxa a barriga para baixo e seu assoalho abre.

Fique aqui pelo tempo todo. Sem esforço. Sem movimento. Apenas respirando no alongamento.

Visualize: um gato se espreguiçando depois da soneca. Patas dianteiras para frente, quadril para trás, barriga caída. Rendição total. Ou cobrindo uma superfície arredondada com uma toalha molhada. A toalha não tem forma própria. Apenas cai.`,
    breathe: 'Inhale to lengthen. Exhale to surrender.',
    breathe_pt: 'Inspire para alongar. Expire para se render.',
    timerCue: `Inhale.
Lengthen.
Exhale.
Surrender.`,
    timerCue_pt: `Inspire.
Alongue.
Expire.
Rendição.`,
    feel: 'Deep opening across the entire pelvic floor. The belly hangs. The floor stretches.',
    feel_pt: 'Abertura profunda em todo o assoalho pélvico. A barriga pendura. O assoalho se alonga.',
    avoid: 'Do not bear down. If knees hurt, cushion between calves and thighs.',
    avoid_pt: 'Não faça força. Se joelhos doem, almofada entre panturrilhas e coxas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  counting_breath: {
    id: 'counting_breath',
    name: 'Counting Breath',
    name_pt: 'Respiração com Contagem',
    sub: 'Count the exhale longer. The floor follows the count.',
    sub_pt: 'Conte a expiração mais longa. O assoalho segue a contagem.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back, knees bent, feet flat. Close your eyes.

Round 1 (5 breaths): Inhale 3 counts. Exhale 5 counts. Short and calm.

Round 2 (5 breaths): Inhale 4 counts. Exhale 6 counts. A bit longer.

Round 3 (5 breaths): Inhale 4 counts. Exhale 8 counts. The longest exhale teaches your nervous system to shift into rest mode. Your pelvic floor softens more with each longer exhale.

If 8 counts is too long, stay at 6. The exhale is always longer than the inhale. That is what tells the body it is safe.

Picture it: slowly letting air out of a balloon. The longer the hiss, the flatter the balloon becomes. Your pelvic floor is the balloon. Or a train slowing into a station. Each longer exhale is a longer brake. By Round 3, the train has stopped completely.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados. Feche os olhos.

Rodada 1 (5 respirações): Inspire 3 tempos. Expire 5 tempos. Curta e calma.

Rodada 2 (5 respirações): Inspire 4 tempos. Expire 6 tempos. Um pouco mais longa.

Rodada 3 (5 respirações): Inspire 4 tempos. Expire 8 tempos. A expiração mais longa ensina seu sistema nervoso a entrar em modo de descanso. Seu assoalho pélvico amolece mais a cada expiração mais longa.

Se 8 tempos for muito, fique em 6. A expiração é sempre mais longa que a inspiração. É isso que diz ao corpo que está seguro.

Visualize: soltando ar lentamente de um balão. Quanto mais longo o chiado, mais murcho fica. Seu assoalho pélvico é o balão. Ou um trem parando numa estação. Cada expiração mais longa é um freio mais longo. Na Rodada 3, o trem parou completamente.`,
    breathe: 'Round 1: in 3, out 5. Round 2: in 4, out 6. Round 3: in 4, out 8.',
    breathe_pt: 'Rodada 1: inspira 3, expira 5. Rodada 2: inspira 4, expira 6. Rodada 3: inspira 4, expira 8.',
    timerCue: `Inhale.
Count.
Exhale.
Longer.`,
    timerCue_pt: `Inspire.
Conte.
Expire.
Mais longo.`,
    feel: 'Each round gets calmer. The longer exhale shifts your whole body into rest mode.',
    feel_pt: 'Cada rodada fica mais calma. A expiração mais longa muda o corpo inteiro para modo de descanso.',
    avoid: 'Do not force longer counts. If dizzy, return to normal breathing. Do not bear down.',
    avoid_pt: 'Não force contagens mais longas. Se sentir tontura, volte à respiração normal. Não faça força.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 7,
    rest: 0,
  },

  gentle_candle_blow: {
    id: 'gentle_candle_blow',
    name: 'Gentle Candle Blow',
    name_pt: 'Sopro de Vela Suave',
    sub: 'The smallest downward intention. 10-15% effort.',
    sub_pt: 'A menor intenção para baixo. 10-15% de esforço.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `Lie on your back, knees bent. Complete 3 belly breaths to prepare.

On your next exhale, add a tiny downward intention. 10% effort. Like gently blowing out a birthday candle, but from below. Not straining. A whisper of movement.

Hold the gentle open feeling for 4 seconds. Then release the effort but stay soft. Breathe normally for 6 seconds.

If 10% feels like too much, try 5%. The effort should be invisible to anyone watching.

Picture it: gently pushing a swing door with your fingertips. It swings open on its own hinges. Or blowing a soap bubble, the effort is tiny, the opening is soft and round.`,
    inst_pt: `Deite de costas, joelhos dobrados. Complete 3 respirações abdominais para preparar.

Na próxima expiração, adicione uma intenção mínima para baixo. 10% de esforço. Como soprar uma vela de aniversário suavemente, mas de baixo. Sem forçar. Um sussurro de movimento.

Mantenha a sensação de abertura suave por 4 segundos. Depois solte o esforço mas continue macia. Respire normalmente por 6 segundos.

Se 10% parecer demais, tente 5%. O esforço deve ser invisível para quem observa.

Visualize: empurrando uma porta vai-e-vem com as pontas dos dedos. Ela abre sozinha. Ou soprando uma bolha de sabão, o esforço é mínimo, a abertura é macia e redonda.`,
    breathe: 'Exhale to push gently down. Inhale to rest.',
    breathe_pt: 'Expire para empurrar suave. Inspire para descansar.',
    timerCue: `Exhale.
Push gently.
Hold.
Release.`,
    timerCue_pt: `Expire.
Empurre suave.
Segure.
Solte.`,
    feel: 'A tiny widening or opening sensation, almost imperceptible. A faint softening that is easy to miss.',
    feel_pt: 'Uma sensação mínima de abertura, quase imperceptível. Um amolecimento sutil, fácil de não perceber.',
    avoid: 'Do not strain. Do not bear down hard. If you feel bulging or pressure, reduce to 5%.',
    avoid_pt: 'Não force. Se sentir protuberância ou pressão, reduza para 5%.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  gentle_push_reset: {
    id: 'gentle_push_reset',
    name: 'Gentle Push Reset',
    name_pt: 'Reset Suave',
    sub: 'After every squeeze set, 3 pushes confirm rest.',
    sub_pt: 'Após cada série de aperto, 3 empurrões confirmam repouso.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `After your squeeze set, exhale and gently push the pelvic floor downward. 15% effort. Hold 4 seconds. Release. Repeat 3 times. This confirms the floor returned to true rest.

Picture it: pressing reset on a stopwatch. Three clicks and you are back to zero.`,
    inst_pt: `Após sua série de aperto, expire e empurre suavemente o assoalho para baixo. 15% esforço. Segure 4 segundos. Solte. Repita 3 vezes. Isso confirma repouso real.

Visualize: apertando reset num cronômetro. Três cliques e volta ao zero.`,
    breathe: 'Exhale to push. Inhale to release.',
    breathe_pt: 'Expire para empurrar. Inspire para soltar.',
    timerCue: `Exhale.
Push.
Release.`,
    timerCue_pt: `Expire.
Empurre.
Solte.`,
    feel: 'Gentle downward opening after each squeeze set.',
    feel_pt: 'Abertura suave para baixo após cada série de aperto.',
    avoid: 'Do not skip after squeeze exercises. Do not strain.',
    avoid_pt: 'Não pule após exercícios de aperto. Não force.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  hip_rock_release: {
    id: 'hip_rock_release',
    name: 'Hip Rock Release',
    name_pt: 'Balanço do Quadril',
    sub: 'Movement teaches the floor to let go.',
    sub_pt: 'Movimento ensina o assoalho a soltar.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back, knees bent, feet flat.

Slowly tilt your pelvis forward: your low back arches slightly away from the floor. Feel your pelvic floor gently stretch open.

Slowly tilt your pelvis back: your low back presses into the floor. Feel your pelvic floor gently compress.

Rock between these two positions slowly. Forward tilt opens the floor. Back tilt closes it lightly. Each rock takes about 4 seconds forward, 4 seconds back.

During the forward tilt, actively breathe into the stretch. Let the floor open.

Picture it: your pelvis is a bowl of water. Tilt forward, water tips toward your belly button. Tilt back, water tips toward your spine. Smooth, no spilling. Or a rocking chair in slow motion, the whole thing moving as one piece.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados.

Lentamente incline a pelve para frente: a lombar se afasta levemente do chão. Sinta o assoalho pélvico se alongar suavemente.

Lentamente incline a pelve para trás: a lombar pressiona o chão. Sinta o assoalho pélvico comprimir levemente.

Balance entre as duas posições devagar. Inclinação frontal abre o assoalho. Inclinação posterior fecha levemente. Cada balanço leva cerca de 4 segundos para frente, 4 para trás.

Durante a inclinação frontal, respire ativamente no alongamento. Deixe o assoalho abrir.

Visualize: sua pelve é uma tigela de água. Incline para frente, água vai ao umbigo. Incline para trás, água vai à coluna. Suave, sem derramar. Ou cadeira de balanço em câmera lenta, tudo se movendo como uma peça.`,
    breathe: 'Inhale as you tilt forward (open). Exhale as you tilt back (neutral).',
    breathe_pt: 'Inspire ao inclinar para frente (abrir). Expire ao inclinar para trás (neutro).',
    timerCue: `Forward.
Open.
Back.
Neutral.`,
    timerCue_pt: `Frente.
Abra.
Trás.
Neutro.`,
    feel: 'A gentle rocking that alternates between stretching and softening. Like a wave inside your pelvis.',
    feel_pt: 'Um balanço suave que alterna entre alongar e amolecer. Como uma onda dentro da pelve.',
    avoid: 'Do not rush. Do not lift your hips off the ground. Do not bear down.',
    avoid_pt: 'Não apresse. Não levante o quadril do chão. Não faça força.',
    type: 'alt',
    sets: 19,
    hold: 4,
    relax: 4,
    rest: 0,
    altA: 'Forward',
    altA_pt: 'Frente',
    altB: 'Back',
    altB_pt: 'Trás',
  },

  pelvic_floor_drop: {
    id: 'pelvic_floor_drop',
    pose: 'pf-drop',
    name: 'Pelvic Floor Drop',
    name_pt: 'Queda do Assoalho',
    sub: 'Gravity does the work. You just breathe.',
    sub_pt: 'A gravidade faz o trabalho. Você só respira.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back. Pull both knees gently toward your chest. Let them fall apart. Hold behind each knee with your hands.

Breathe in for 4 counts. Feel your pelvic floor widen between your sit bones.

Breathe out for 6 counts. Let everything drop. Nothing holds.

On each exhale, imagine the space between your sit bones getting 1mm wider. Stay in this position for the full time.

Picture it: two small islands drifting apart on a calm ocean. Each breath pushes them gently further.`,
    inst_pt: `Deite de costas. Puxe os joelhos suavemente em direção ao peito. Deixe-os cair para os lados. Segure atrás de cada joelho com as mãos.

Inspire por 4 tempos. Sinta seu assoalho pélvico alargar entre os ísquios.

Expire por 6 tempos. Deixe tudo cair. Nada segura.

Em cada expiração, imagine o espaço entre seus ísquios ficando 1mm mais largo. Fique aqui pelo tempo todo.

Visualize: duas pequenas ilhas se afastando num oceano calmo. Cada respiração as empurra suavemente.`,
    breathe: 'Inhale to widen. Exhale to drop deeper.',
    breathe_pt: 'Inspire para alargar. Expire para soltar mais fundo.',
    timerCue: `Inhale.
Widen.
Exhale.
Drop.`,
    timerCue_pt: `Inspire.
Alargue.
Expire.
Solte.`,
    feel: 'A gentle opening between the sit bones on every breath. Gravity pulling the floor downward. No effort.',
    feel_pt: 'Uma abertura suave entre os ísquios a cada respiração. Gravidade puxando o assoalho para baixo. Sem esforço.',
    avoid: 'Do not push or bear down. Do not squeeze your knees together. Do not tense your inner thighs.',
    avoid_pt: 'Não empurre nem faça força. Não aperte os joelhos juntos. Não tensione as coxas internas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  push_and_return: {
    id: 'push_and_return',
    name: 'Push and Return',
    name_pt: 'Empurre e Volte',
    sub: 'Down 20%. Back to neutral. Learning two directions.',
    sub_pt: 'Desça 20%. Volte ao neutro. Aprendendo duas direções.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `Sit on a firm chair, feet flat.

Exhale and gently push the pelvic floor downward. 20% effort. Hold for 4 seconds.

Inhale and let the floor return to neutral. Not squeezing up. Just neutral. Like a trampoline bouncing back to resting position after a gentle press.

The return is NOT a squeeze. It is a passive bounce back.

Picture it: pressing a piano key down gently, then letting your finger lift. The key returns on its own spring. Or pressing a sponge underwater and letting it expand back.`,
    inst_pt: `Sente numa cadeira firme, pés apoiados.

Expire e empurre suavemente o assoalho para baixo. 20% esforço. Segure por 4 segundos.

Inspire e deixe o assoalho voltar ao neutro. Não apertando para cima. Apenas neutro. Como um trampolim voltando após pressão suave.

O retorno NÃO é um aperto. É um retorno passivo.

Visualize: pressionando tecla de piano suavemente, depois deixando voltar. A tecla volta pela mola. Ou pressionando esponja na água e deixando expandir.`,
    breathe: 'Exhale to push. Inhale to return.',
    breathe_pt: 'Expire para empurrar. Inspire para voltar.',
    timerCue: `Exhale.
Push.
Inhale.
Return.`,
    timerCue_pt: `Expire.
Empurre.
Inspire.
Volte.`,
    feel: 'A gentle downward movement followed by a natural return.',
    feel_pt: 'Um movimento suave para baixo seguido de retorno natural.',
    avoid: 'Do not squeeze on the return. Do not bear down hard.',
    avoid_pt: 'Não aperte no retorno. Não faça força.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  squeeze_3s: {
    id: 'squeeze_3s',
    name: 'Foundation Squeeze 3s',
    name_pt: 'Aperto Base 3s',
    sub: 'CLOSE and SQUEEZE at 40%. Hold 3 seconds. Release fully.',
    sub_pt: 'FECHE e APERTE em 40%. Segure 3 segundos. Solte totalmente.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Lie on your back, knees bent.

CLOSE the pelvic walls inward and SQUEEZE upward at 40% effort. Hold for 3 seconds. Breathe normally while holding.

Release completely for 5 seconds. Full drop. The release matters as much as the lift.

If you cannot feel the squeeze at all, try stopping an imaginary urine stream. That is the muscle group. Once found, never use the stop-urine method as a regular exercise.

Picture it: picking up a grape without crushing it. Hold for 3 seconds. Set it down gently. Or closing a zipper halfway, holding, then unzipping completely.`,
    inst_pt: `Deite de costas, joelhos dobrados.

FECHE as paredes pélvicas para dentro e APERTE para cima com 40% esforço. Segure por 3 segundos. Respire normalmente.

Solte completamente por 5 segundos. Queda total. A soltura importa tanto quanto o aperto.

Se não sentir o aperto, tente parar um jato imaginário de urina. Esse é o grupo muscular. Uma vez encontrado, nunca use o método de parar urina como exercício.

Visualize: pegando uma uva sem esmagar. Segure 3 segundos. Coloque suavemente. Ou fechando zíper até a metade, segurando, depois abrindo completamente.`,
    breathe: 'Exhale to CLOSE and SQUEEZE. Inhale to release.',
    breathe_pt: 'Expire para FECHAR e APERTAR. Inspire para soltar.',
    timerCue: `Squeeze.
Hold 3.
Release.`,
    timerCue_pt: `Aperte.
Segure 3.
Solte.`,
    feel: 'A gentle inward and upward movement. Not in the buttocks. Not in the thighs.',
    feel_pt: 'Um movimento suave para dentro e para cima. Não nos glúteos. Não nas coxas.',
    avoid: 'Do not hold breath. Do not bear down. Do not clench buttocks or inner thighs.',
    avoid_pt: 'Não prenda respiração. Não faça força. Não contraia glúteos ou coxas internas.',
    type: 'hold',
    sets: 19,
    hold: 3,
    relax: 5,
    rest: 0,
  },
};

export const days = [
  {
    day: 61, week: 9,
    title: 'Day 61', title_pt: 'Dia 61',
    exercises: [
      { ref: 'push_and_return', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 62, week: 9,
    title: 'Day 62', title_pt: 'Dia 62',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'push_and_return', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 63, week: 9,
    title: 'Day 63', title_pt: 'Dia 63',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'push_and_return', overrides: {"sets": 10} }, // 100s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 64, week: 10,
    title: 'Day 64', title_pt: 'Dia 64',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'counting_breath', overrides: {"sets": 14} }, // 154s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 65, week: 10,
    title: 'Day 65', title_pt: 'Dia 65',
    exercises: [
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'gentle_candle_blow', overrides: {"sets": 11} }, // 110s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 66, week: 10,
    title: 'Day 66', title_pt: 'Dia 66',
    exercises: [
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'pelvic_floor_drop', overrides: {"hold": 104} }, // 104s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 67, week: 10,
    title: 'Day 67', title_pt: 'Dia 67',
    exercises: [
      { ref: 'pelvic_floor_drop', overrides: {} }, // 150s
      { ref: 'counting_breath', overrides: {"sets": 14} }, // 154s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 68, week: 10,
    title: 'Day 68', title_pt: 'Dia 68',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
      { ref: 'push_and_return', overrides: {"sets": 10} }, // 100s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 69, week: 10,
    title: 'Day 69', title_pt: 'Dia 69',
    exercises: [
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
    ], // Total: 299s = 5.0 min
  },
  {
    day: 70, week: 10,
    title: 'Day 70', title_pt: 'Dia 70',
    exercises: [
      { ref: 'squeeze_3s', overrides: {} }, // 152s
      { ref: 'counting_breath', overrides: {"sets": 13} }, // 143s
    ], // Total: 295s = 4.9 min
  },
  {
    day: 71, week: 11,
    title: 'Day 71', title_pt: 'Dia 71',
    exercises: [
      { ref: 'pelvic_floor_drop', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 72, week: 11,
    title: 'Day 72', title_pt: 'Dia 72',
    exercises: [
      { ref: 'push_and_return', overrides: {} }, // 150s
      { ref: 'hip_rock_release', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 73, week: 11,
    title: 'Day 73', title_pt: 'Dia 73',
    exercises: [
      { ref: 'pelvic_floor_drop', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
      { ref: 'squeeze_3s', overrides: {"sets": 13} }, // 104s
    ], // Total: 303.0s = 5.0 min
  },
  {
    day: 74, week: 11,
    title: 'Day 74', title_pt: 'Dia 74',
    exercises: [
      { ref: 'counting_breath', overrides: {"sets": 14} }, // 154s
      { ref: 'hip_rock_release', overrides: {"sets": 18} }, // 144s
    ], // Total: 298s = 5.0 min
  },
  {
    day: 75, week: 11,
    title: 'Day 75', title_pt: 'Dia 75',
    exercises: [
      { ref: 'gentle_candle_blow', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 76, week: 11,
    title: 'Day 76', title_pt: 'Dia 76',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 77, week: 11,
    title: 'Day 77', title_pt: 'Dia 77',
    exercises: [
      { ref: 'gentle_candle_blow', overrides: {} }, // 150s
      { ref: 'push_and_return', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 78, week: 12,
    title: 'Day 78', title_pt: 'Dia 78',
    exercises: [
      { ref: 'pelvic_floor_drop', overrides: {} }, // 150s
      { ref: 'gentle_candle_blow', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 79, week: 12,
    title: 'Day 79', title_pt: 'Dia 79',
    exercises: [
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
      { ref: 'push_and_return', overrides: {"sets": 10} }, // 100s
    ], // Total: 299s = 5.0 min
  },
  {
    day: 80, week: 12,
    title: 'Day 80', title_pt: 'Dia 80',
    exercises: [
      { ref: 'push_and_return', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 81, week: 12,
    title: 'Day 81', title_pt: 'Dia 81',
    exercises: [
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
      { ref: 'push_and_return', overrides: {"sets": 10} }, // 100s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 82, week: 12,
    title: 'Day 82', title_pt: 'Dia 82',
    exercises: [
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
      { ref: 'pelvic_floor_drop', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 83, week: 12,
    title: 'Day 83', title_pt: 'Dia 83',
    exercises: [
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
      { ref: 'counting_breath', overrides: {"sets": 9} }, // 99s
      { ref: 'push_and_return', overrides: {"sets": 10} }, // 100s
    ], // Total: 295s = 4.9 min
  },
  {
    day: 84, week: 12,
    title: 'Day 84', title_pt: 'Dia 84',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 85, week: 13,
    title: 'Day 85', title_pt: 'Dia 85',
    exercises: [
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_candle_blow', overrides: {"sets": 10} }, // 100s
    ], // Total: 300.0s = 5.0 min
  },
  {
    day: 86, week: 13,
    title: 'Day 86', title_pt: 'Dia 86',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'counting_breath', overrides: {"sets": 14} }, // 154s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 87, week: 13,
    title: 'Day 87', title_pt: 'Dia 87',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 88, week: 13,
    title: 'Day 88', title_pt: 'Dia 88',
    exercises: [
      { ref: 'push_and_return', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 89, week: 13,
    title: 'Day 89', title_pt: 'Dia 89',
    exercises: [
      { ref: 'push_and_return', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'pelvic_floor_drop', overrides: {"hold": 100} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 90, week: 13,
    title: 'Day 90', title_pt: 'Dia 90',
    exercises: [
      { ref: 'counting_breath', overrides: {"sets": 14} }, // 154s
      { ref: 'push_and_return', overrides: {} }, // 150s
    ], // Total: 304s = 5.1 min
  },
];

export const milestone = {
  title: 'Month 3 Check-in',
  title_pt: 'Check-in do Mes 3',
  questions: [
    {
      q: 'Can you squeeze at 30% for 3 seconds without pain?',
      q_pt: 'Consegue apertar em 30% por 3 segundos sem dor?',
      yes_response: 'You are on track. Continue to the next month.',
      yes_response_pt: 'Voce esta no caminho. Continue para o proximo mes.',
      no_response: 'Repeat this month for 2 more weeks. If no progress after 6 weeks total, consult a pelvic floor physiotherapist.',
      no_response_pt: 'Repita este mes por mais 2 semanas. Se sem progresso apos 6 semanas, consulte fisioterapeuta de assoalho pelvico.',
    },
  ],
};

export const monthMeta = {
  month: 3,
  program: 'release',
  phase: 'Three Movements Together',
  phase_pt: 'Tres Movimentos Juntos',
  days_range: [61, 90],
  session_target_seconds: 300,
};

export function resolveDay(dayNumber) {
  const dayData = days.find(d => d.day === dayNumber);
  if (!dayData) return null;
  return { ...dayData, exercises: dayData.exercises.map(ex => ({ ...exercises[ex.ref], ...ex.overrides })) };
}